<template>
  <div class="emp-novi">
    <!-- ZAGLAVLJE (sticky) -->
    <div class="traka-radnik">
      <div class="avatar">{{ inicijali }}</div>
      <div class="traka-tekst">
        <div class="naslov">
          {{ punoIme }}
          <span v-if="employee.Activ" class="znak aktivan">{{ T.aktivan }}</span>
          <span v-else class="znak neaktivan">{{ T.neaktivan }}</span>
        </div>
        <div class="pod">{{ podZaglavlje }}</div>
      </div>
      <div class="razmak"></div>
      <div class="akcije">
        <v-btn v-if="razina <= 3" small depressed class="gumb-bijeli" @click="$emit('uredi')">{{ T.uredi }}</v-btn>
        <v-btn v-if="razina <= 3" small outlined dark class="gumb-duh" @click="$emit('uredi-placu')">{{ lang.Edit2 }}</v-btn>
        <v-btn v-if="razina <= 3" small outlined dark class="gumb-duh" @click="$emit('uredi-dodatne')">{{ lang.Edit3 }}</v-btn>
        <span class="odvoji"></span>
        <v-btn v-if="razina <= 3" small outlined dark class="gumb-duh" @click="$emit('ispis')">{{ langC.Print }}</v-btn>
        <v-btn v-if="razina <= 3" small outlined dark class="gumb-duh" @click="$emit('r1')">Potvrda o plaći (R-1)</v-btn>
        <v-btn v-if="razina <= 3" small outlined dark class="gumb-duh" @click="$emit('neoporezivo')">Neoporezivi primici</v-btn>
        <v-btn small outlined dark class="gumb-duh" @click="$emit('stari-izgled')">
          <v-icon small left>mdi-undo-variant</v-icon>{{ T.stariIzgled }}
        </v-btn>
        <v-btn small depressed color="green" dark @click="$emit('natrag')">{{ langC.Back }}</v-btn>
      </div>
    </div>

    <!-- TRAKA S BROJKAMA -->
    <div class="brojke">
      <template v-for="(b, i) in brojke">
        <div v-if="i > 0" :key="'c' + b.l" class="crta"></div>
        <div :key="b.l" class="stavka">
          <span>{{ b.l }}</span>
          <b :class="{ glavno: b.glavno }">{{ b.v }}</b>
        </div>
      </template>
    </div>

    <div class="prekidac">
      <v-checkbox v-model="prikaziSve" dense hide-details class="mt-0 pt-0" :label="T.prikaziSva"></v-checkbox>
    </div>

    <div class="stupci">
      <!-- ================= LIJEVI STUPAC ================= -->
      <div>
        <div class="kartica">
          <div class="naslov-kartice">{{ T.osobni }}</div>
          <div class="tijelo"><PoljaRedovi :redovi="osobni" :sve="prikaziSve" /></div>
        </div>

        <div class="kartica">
          <div class="naslov-kartice">{{ T.kontakt }}</div>
          <div class="tijelo"><PoljaRedovi :redovi="kontakt" :sve="prikaziSve" /></div>
        </div>

        <div class="kartica">
          <div class="naslov-kartice">{{ T.zaposlenje }} <span class="dodatak">{{ brojPopunjenih(zaposlenje) }}</span></div>
          <div class="tijelo"><PoljaRedovi :redovi="zaposlenje" :sve="prikaziSve" /></div>
        </div>

        <div class="kartica">
          <div class="naslov-kartice">{{ lang.WorkStatus }}</div>
          <div class="tijelo bez">
            <v-data-table
              dense
              :headers="headers2"
              :items="items2"
              :footer-props="{ 'items-per-page-options': [10, 20, 30, 40, 50] }"
              :items-per-page="50"
            >
              <template v-slot:[`item.OpenDate`]="{ item }">
                <span>{{ localDate(item.OpenDate) }}</span>
              </template>
              <template slot="pageText" slot-scope="{ pageStart, pageStop }">
                {{ T.od }} {{ pageStart }} {{ T.do }} {{ pageStop }}
              </template>
            </v-data-table>
          </div>
        </div>

        <div class="kartica">
          <div class="naslov-kartice">{{ T.arhiva }}</div>
          <div class="tijelo"><DigitalDocShortList /></div>
        </div>

        <div v-if="razina == 1" class="opasna-zona">
          <v-btn small outlined color="red darken-1" @click="$emit('obrisi')">
            <v-icon small left>mdi-delete-outline</v-icon>{{ langC.Delete }}
          </v-btn>
          <span class="opasna-napomena">Brisanje radnika (otvara se potvrda).</span>
        </div>
      </div>

      <!-- ================= DESNI STUPAC ================= -->
      <div>
        <div class="kartica">
          <div class="naslov-kartice">{{ T.placa }} <span class="dodatak">EUR</span></div>
          <div class="tijelo">
            <table class="obracun">
              <template v-for="(r, i) in obracun">
                <tr v-if="!r.prazan || prikaziSve" :key="'o' + i" :class="r.klasa">
                  <td v-if="r.klasa === 'skupina'" colspan="2">{{ r.l }}</td>
                  <template v-else>
                    <td>{{ r.l }} <span v-if="r.sitno" class="sitno">{{ r.sitno }}</span></td>
                    <td>{{ r.v }}</td>
                  </template>
                </tr>
              </template>
            </table>
          </div>
        </div>

        <div class="kartica">
          <div class="naslov-kartice sklopiva" @click="otvoreno.banka = !otvoreno.banka">
            {{ T.banka }} <span class="dodatak">{{ bankaBrojac }}</span>
            <span class="strelica">{{ otvoreno.banka || prikaziSve ? '▴' : '▾' }}</span>
          </div>
          <div v-show="otvoreno.banka || prikaziSve" class="tijelo">
            <PoljaRedovi :redovi="banka" :sve="prikaziSve" :nema="T.nemaPodataka" />
          </div>
        </div>

        <div class="kartica">
          <div class="naslov-kartice sklopiva" @click="otvoreno.zastita = !otvoreno.zastita">
            {{ T.zastita }} <span class="dodatak">{{ brojPopunjenih(zastita) }}</span>
            <span class="strelica">{{ otvoreno.zastita || prikaziSve ? '▴' : '▾' }}</span>
          </div>
          <div v-show="otvoreno.zastita || prikaziSve" class="tijelo">
            <PoljaRedovi :redovi="zastita" :sve="prikaziSve" dugi :nema="T.nemaPodataka" />
          </div>
        </div>

        <div class="kartica">
          <div class="naslov-kartice sklopiva" @click="otvoreno.odjeca = !otvoreno.odjeca">
            {{ T.odjeca }} <span class="dodatak">{{ T.osobneMjere }} · {{ brojPopunjenih(odjeca) }}</span>
            <span class="strelica">{{ otvoreno.odjeca || prikaziSve ? '▴' : '▾' }}</span>
          </div>
          <div v-show="otvoreno.odjeca || prikaziSve" class="tijelo">
            <PoljaRedovi :redovi="odjeca" :sve="prikaziSve" :nema="T.nemaPodataka" />
          </div>
        </div>

        <div class="kartica">
          <div class="naslov-kartice">{{ T.zapis }}</div>
          <div class="tijelo"><PoljaRedovi :redovi="zapis" :sve="prikaziSve" /></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DigitalDocShortList from '../DigitalDoc/DigitalDocShortList.vue'
import dateFormat from '@/snippets/dateFormat'
import { moneyFormat } from '@/snippets/allSnippets'
import { jePrazno, bankaImaPodatke } from './employeeViewNoviHelper'

// Popis polja: red je prazan ako vrijednost nije upisana (nula je upisana
// vrijednost). Prazni redovi se skrivaju dok se ne ukljuci "Prikaži sva polja".
const PoljaRedovi = {
  name: 'PoljaRedovi',
  props: {
    redovi: { type: Array, default: () => [] },
    sve: { type: Boolean, default: false },
    dugi: { type: Boolean, default: false },
    nema: { type: String, default: '' }
  },
  computed: {
    vidljivi () {
      return this.redovi.filter(r => this.sve || !jePrazno(r.v))
    }
  },
  render (h) {
    if (!this.vidljivi.length) {
      return this.nema ? h('div', { class: 'nema-podataka' }, this.nema) : null
    }
    const djeca = []
    this.vidljivi.forEach(r => {
      const prazno = jePrazno(r.v)
      djeca.push(h('div', { class: 'naziv' }, r.l))
      djeca.push(h('div', { class: ['vrijednost', { prazno }] }, prazno ? '—' : String(r.v)))
    })
    return h('div', { class: ['polja', { dugi: this.dugi }] }, djeca)
  }
}

export default {
  name: 'EmployeeViewNovi',
  components: { DigitalDocShortList, PoljaRedovi },
  props: {
    employee: { type: Object, default: () => ({}) },
    items2: { type: Array, default: () => [] },
    headers2: { type: Array, default: () => [] },
    lang: { type: Object, default: () => ({}) },
    langC: { type: Object, default: () => ({}) },
    locDateOfBirht: { type: String, default: '' },
    locStartInCompany: { type: String, default: '' },
    locEndDateInCompany: { type: String, default: '' },
    locCreatedAt: { type: String, default: '' },
    locUpdatedAt: { type: String, default: '' }
  },
  data () {
    return {
      prikaziSve: false,
      otvoreno: { banka: false, zastita: false, odjeca: false }
    }
  },
  computed: {
    razina () { return this.$store.state.user.AccessLevel },
    hr () { return this.$store.state.language !== 'EN' },
    T () {
      const hr = this.hr
      return {
        aktivan: hr ? 'aktivan' : 'active',
        neaktivan: hr ? 'neaktivan' : 'inactive',
        uredi: hr ? 'Uredi' : 'Edit',
        stariIzgled: hr ? 'Stari izgled' : 'Old layout',
        prikaziSva: hr ? 'Prikaži sva polja (i prazna)' : 'Show all fields (including empty)',
        osobni: hr ? 'Osobni podaci' : 'Personal data',
        kontakt: hr ? 'Kontakt i adresa' : 'Contact and address',
        zaposlenje: hr ? 'Zaposlenje' : 'Employment',
        arhiva: hr ? 'Digitalna arhiva' : 'Digital archive',
        placa: hr ? 'Plaća i obračun' : 'Salary and calculation',
        banka: hr ? 'Banka i isplata' : 'Bank and payment',
        zastita: hr ? 'Zaštita i status radnika' : 'Protection and status',
        odjeca: hr ? 'Radna odjeća' : 'Work clothes',
        osobneMjere: hr ? 'osobne mjere' : 'personal sizes',
        zapis: hr ? 'Zapis' : 'Record',
        nemaPodataka: hr ? 'Nema upisanih podataka.' : 'No data entered.',
        od: hr ? 'od' : 'from',
        do: hr ? 'do' : 'to',
        popunjeno: hr ? 'popunjeno' : 'filled',
        racuna: hr ? 'računa' : 'accounts'
      }
    },
    punoIme () { return [this.employee.First, this.employee.Last].filter(x => x).join(' ') },
    inicijali () {
      const i = [this.employee.First, this.employee.Last].map(x => (x ? String(x).trim().charAt(0) : '')).join('')
      return i.toUpperCase() || '?'
    },
    podZaglavlje () {
      const e = this.employee
      const d = []
      if (!jePrazno(e.VatID)) d.push('OIB ' + e.VatID)
      if (!jePrazno(e.PersonalID2)) d.push('MBO ' + e.PersonalID2)
      if (!jePrazno(e.WorkPlace)) d.push(e.WorkPlace)
      if (!jePrazno(e.hashtag)) d.push(e.hashtag)
      return d.join(' · ')
    },
    brojke () {
      const e = this.employee
      const hr = this.hr
      const b = [
        { l: 'Bruto 1', v: this.eur(e.FinBruto1), glavno: true },
        { l: 'Neto 1', v: this.eur(e.FinNeto1) },
        { l: 'Neto 2', v: this.eur(e.FinNeto2) },
        { l: hr ? 'Neto 3 (za isplatu)' : 'Neto 3', v: this.eur(e.FinNeto3) },
        { l: 'Bruto 3', v: this.eur(e.FinBruto3) }
      ]
      if (this.locStartInCompany) b.push({ l: this.lang.StartInCompany, v: this.locStartInCompany })
      if (!jePrazno(e.WeeklyWorkHours)) b.push({ l: this.lang.WeeklyWorkHours, v: e.WeeklyWorkHours })
      return b
    },
    osobni () {
      const e = this.employee
      const l = this.lang
      return [
        { l: this.cisto(l.First), v: e.First },
        { l: this.cisto(l.Last), v: e.Last },
        { l: l.Gender, v: e.Gender },
        { l: this.cisto(l.DateOfBirht), v: this.locDateOfBirht },
        { l: l.PlaceOfBirht, v: e.PlaceOfBirht },
        { l: l.PlaceOfBirthState, v: e.PlaceOfBirthState },
        { l: this.cisto(l.VatID), v: e.VatID },
        { l: l.PersonalID1, v: e.PersonalID1 },
        { l: l.PersonalID2, v: e.PersonalID2 },
        { l: l.Foriner, v: e.Foriner },
        { l: l.ForinerLicense, v: e.ForinerLicense }
      ]
    },
    kontakt () {
      const e = this.employee
      return [
        { l: 'Email', v: e.eemail },
        { l: this.lang.phone, v: e.phone },
        { l: this.lang.PlaceOfLive, v: e.PlaceOfLive }
      ]
    },
    zaposlenje () {
      const e = this.employee
      const l = this.lang
      const radDo = (e.WorkYearsBefore || e.WorkMonthsBefore || e.WorkDaysBefore)
        ? `${l.WorkYearsBefore}: ${e.WorkYearsBefore || 0} · ${l.WorkMonthsBefore}: ${e.WorkMonthsBefore || 0} · ${l.WorkDaysBefore}: ${e.WorkDaysBefore || 0}`
        : ''
      const kod = jePrazno(e.WorkInCityCode) || String(e.WorkInCityCode) === '0' ? '' : e.WorkInCityCode
      const radMjesto = [kod, e.WorkInCityName].filter(x => !jePrazno(x)).join(', ')
      return [
        { l: this.cisto(l.CompanyName), v: e.CompanyNameDatabase },
        { l: l.Activ, v: e.Activ ? '✓ ' + (this.hr ? 'da' : 'yes') : (this.hr ? 'ne' : 'no') },
        { l: 'Hashtag', v: e.hashtag },
        { l: l.WorkPlace, v: e.WorkPlace },
        { l: l.Occupation, v: e.Occupation },
        { l: l.Degree, v: e.Degree },
        { l: l.SpecialKnowledge, v: e.SpecialKnowledge },
        { l: l.StartInCompany, v: this.locStartInCompany },
        { l: l.WorkBefore, v: radDo },
        { l: l.WorkInCityCodeID, v: radMjesto },
        { l: l.WeeklyWorkHours, v: e.WeeklyWorkHours },
        { l: l.NotWorkingTime, v: e.NotWorkingTime },
        { l: 'Oznaka staža sa pov.trajanjem (0 ili 1)', v: e.Joppd71Oznaka },
        { l: l.WorkHardConditions, v: e.WorkHardConditions },
        { l: l.WorkForOtherCompany, v: e.WorkForOtherCompany },
        { l: l.WorkForOtherCompanyAbroad, v: e.WorkForOtherCompanyAbroad },
        { l: l.WorkForOtherConnectedCompany, v: e.WorkForOtherConnectedCompany },
        { l: l.EndDateInCompany, v: this.locEndDateInCompany },
        { l: l.EndReason, v: e.EndReason }
      ]
    },
    zastita () {
      const e = this.employee
      const l = this.lang
      return [
        'Pregnancy', 'Maternity', 'Breastfeeding', 'OnlyParent', 'AdoptionStatus', 'ProfessionalIllnes',
        'HurtOnWork', 'ProfessionalCantWork', 'ProfessionalLowerAbbilities', 'ProfessionalLoseWrokAbbility',
        'DangerOfLosingProfAbbilityInjury', 'DangerOfHaveDisability', 'Disability', 'DisabilityPension',
        'DisabilityWorkTIme', 'WorkForOtherEmployee'
      ].map(k => ({ l: l[k], v: e[k] }))
    },
    odjeca () {
      const e = this.employee
      const l = this.lang
      return [
        { l: l.PersonalHeight, v: e.PersonalHeight },
        { l: l.PersonalSizeUp, v: e.PersonalSizeUp },
        { l: l.PersonalSizeDown, v: e.PersonalSizeDown },
        { l: l.PersonalShoes, v: e.PersonalShoes }
      ]
    },
    zapis () {
      return [
        { l: this.lang.OtherData, v: this.employee.OtherData },
        { l: this.langC.CreatedAt, v: this.locCreatedAt },
        { l: this.langC.UpdatedAt, v: this.locUpdatedAt }
      ]
    },
    banka () {
      const e = this.employee
      const hr = this.hr
      const r = []
      const dodaj = (n, naziv) => {
        const ime = e['Fin' + n + 'bankAccountName']
        r.push({ l: naziv + (jePrazno(ime) ? '' : ' — ' + ime), v: this.bankNr(e['Fin' + n + 'bankAccountNr1']) })
        const n2 = e['Fin' + n + 'bankAccountNr2']
        const n3 = e['Fin' + n + 'bankAccountNr3']
        r.push({ l: hr ? 'Poziv na broj' : 'Call on', v: jePrazno(n2) && jePrazno(n3) ? '' : (n2 || '') + ' ___ ' + (n3 || '') })
      }
      dodaj(1, hr ? 'Banka' : 'Bank')
      dodaj(2, hr ? 'Banka zaštićeni račun' : 'Bank protected')
      return r
    },
    bankaBrojac () {
      const n = [1, 2].filter(i => bankaImaPodatke(this.employee, i)).length
      return `${n} ${this.hr ? 'od' : 'of'} 2 ${this.T.racuna}`
    },

    // ---- obračun: redovi Bruto 1 -> Bruto 3, prazni (nula) redovi se skrivaju ----
    obracun () {
      const e = this.employee
      const hr = this.hr
      const r = []
      const stavka = (l, sitno, v, prazan) => r.push({ klasa: 'uvuceno', l, sitno, v: this.m(v), prazan: !!prazan })
      const zbroj = (l, v) => r.push({ klasa: 'zbroj', l, v: this.m(v) })
      const skupina = (l) => r.push({ klasa: 'skupina', l })
      const poz = (x) => x > 0

      r.push({ klasa: 'glavni', l: 'Bruto 1', v: this.m(e.FinBruto1) })
      for (let i = 1; i <= 3; i++) {
        const k = e['FinKoef' + i]
        const opis = e['FinKoef' + i + 'Desc']
        r.push({ klasa: 'uvuceno', l: 'Koef ' + i, sitno: jePrazno(opis) ? '' : opis, v: poz(k) ? k : '—', prazan: !poz(k) })
      }
      zbroj(hr ? 'Dohodak (Bruto 2)' : 'Income (Bruto 2)', e.FinBruto2)

      skupina(hr ? 'Doprinosi iz plaće' : 'Contributions from salary')
      for (let i = 1; i <= 5; i++) {
        const p = e['FinFrom' + i + 'Per']
        const a = e['FinFrom' + i + 'Am']
        stavka(this.opisILI(e['FinFrom' + i + 'Desc'], (hr ? 'Doprinos ' : 'Contribution ') + i), poz(p) ? this.pos(p) : '', a, !poz(p) && !poz(a))
      }
      zbroj('Neto 1', e.FinNeto1)

      skupina(hr ? 'Olakšice i porez' : 'Allowances and tax')
      // Olakšica n: iznos je FinFree{n}Am (ne FinFree1Am, kako je u starom izgledu).
      // Iznos se uzima i kad je indeks 0, jer se FinFree2Am/FinFree3Am u obračunu
      // postavljaju izravno (iznos djeteta / uzdržavanih), bez indeksa.
      for (let i = 1; i <= 3; i++) {
        const ind = e['FinFree' + i + 'Indeks']
        const on = e['FinFree' + i + 'OnAm']
        const a = e['FinFree' + i + 'Am']
        const sitno = poz(ind) ? `${ind} × ${this.m(on)}` : ''
        stavka(this.opisILI(e['FinFree' + i + 'Desc'], (hr ? 'Olakšica ' : 'Allowance ') + i), sitno, a, !poz(ind) && !poz(a))
      }
      r.push({
        klasa: 'uvuceno',
        l: hr ? 'Ukupno olakšice' : 'Total allowances',
        sitno: (hr ? 'indeks ' : 'index ') + e.FinFreeTotalIndeks,
        v: this.m(e.FinFreeTotalAm),
        prazan: !poz(e.FinFreeTotalAm)
      })
      // Porez n: u obračunu je FinTax{n}From osnovica na koju se stopa primjenjuje,
      // FinTax{n}Am je iznos poreza (stari izgled je dvaput ispisivao FinTax{n}Am).
      for (let i = 1; i <= 3; i++) {
        const p = e['FinTax' + i + 'Per']
        const od = e['FinTax' + i + 'From']
        const a = e['FinTax' + i + 'Am']
        const sitno = (poz(p) ? this.pos(p) : '') + (poz(od) ? (poz(p) ? ' · ' : '') + (hr ? 'osnovica ' : 'base ') + this.m(od) : '')
        stavka((hr ? 'Porez na dohodak — stupanj ' : 'Income tax — bracket ') + i, sitno, a, !poz(p) && !poz(a))
      }
      // Prirez: red se vidi i kad je postotak 0, ali je upisan grad (inače se
      // grad prireza nigdje ne bi vidio).
      const grad = [e.FinTaxOnTaxCityCode, e.FinTaxOnTaxCityName].filter(x => !jePrazno(x) && String(x) !== '0').join(' ')
      const prirezSitno = [poz(e.FinTaxOnTaxPer) ? this.pos(e.FinTaxOnTaxPer) : '', grad].filter(x => x).join(' · ')
      stavka(hr ? 'Prirez' : 'City tax', prirezSitno, e.FinTaxOnTaxAm, !poz(e.FinTaxOnTaxPer) && !poz(e.FinTaxOnTaxAm) && !grad)
      zbroj('Neto 2', e.FinNeto2)

      skupina(hr ? 'Neoporezivi dodaci' : 'Non-taxable additions')
      stavka(hr ? 'Prijevoz' : 'Travel', '', e.FinTravelAm, !poz(e.FinTravelAm))
      stavka(hr ? 'Ostali dodatak' : 'Other bonus', '', e.FinOther1Am, !poz(e.FinOther1Am))
      stavka(hr ? 'Ostali dodatak 2' : 'Other bonus 2', '', e.FinOther2Am, !poz(e.FinOther2Am))
      zbroj(hr ? 'Neto 3 (za isplatu)' : 'Neto 3', e.FinNeto3)

      skupina(hr ? 'Doprinosi na plaću' : 'Contributions on salary')
      for (let i = 1; i <= 5; i++) {
        const p = e['FinTo' + i + 'Per']
        const a = e['FinTo' + i + 'Am']
        stavka(this.opisILI(e['FinTo' + i + 'Desc'], (hr ? 'Doprinos ' : 'Contribution ') + i), poz(p) ? this.pos(p) : '', a, !poz(p) && !poz(a))
      }
      zbroj('Bruto 3', e.FinBruto3)
      return r
    }
  },
  methods: {
    localDate (d) { return dateFormat(d) },
    m (v) { return typeof v === 'string' && v === '—' ? v : moneyFormat(v) },
    eur (v) { return moneyFormat(v) + ' EUR' },
    pos (p) { return String(p).replace('.', ',') + ' %' },
    opisILI (opis, zamjena) { return jePrazno(opis) ? zamjena : String(opis).trim() },
    cisto (t) { return t ? String(t).replace(/\s*\*\s*$/, '').trim() : t },
    bankNr (v) { return jePrazno(v) || String(v) === '0' ? '' : v },
    brojPopunjenih (redovi) {
      const n = redovi.filter(r => !jePrazno(r.v)).length
      return `${n} ${this.hr ? 'od' : 'of'} ${redovi.length} ${this.T.popunjeno}`
    }
  }
}
</script>

<style scoped>
.emp-novi {
  --plava: #1976d2;
  --plava-tamna: #1565c0;
  --plava-svijetla: #eef4fb;
  --crta: rgba(0, 0, 0, 0.12);
  --sivo: rgba(0, 0, 0, 0.6);
}
.traka-radnik {
  position: sticky; top: 0; z-index: 5;
  display: flex; align-items: center; gap: 14px; flex-wrap: wrap;
  background: var(--plava); color: #fff;
  border-radius: 4px; padding: 10px 14px; margin-bottom: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}
.avatar {
  width: 48px; height: 48px; border-radius: 50%; flex: none;
  background: rgba(255, 255, 255, 0.22); border: 2px solid rgba(255, 255, 255, 0.5);
  display: flex; align-items: center; justify-content: center;
  font-size: 18px; font-weight: 700;
}
.traka-radnik .naslov { font-size: 20px; font-weight: 700; line-height: 1.2; }
.traka-radnik .pod { font-size: 13px; opacity: 0.92; margin-top: 3px; }
.traka-radnik .razmak { flex: 1; }
.znak {
  display: inline-block; font-size: 12px; font-weight: 500;
  background: rgba(255, 255, 255, 0.22); border-radius: 10px;
  padding: 1px 9px; margin-left: 4px; vertical-align: middle;
}
.znak.aktivan { background: #43a047; }
.znak.neaktivan { background: #c62828; }
.akcije { display: flex; align-items: center; gap: 6px; flex-wrap: wrap; }
.akcije .odvoji { width: 1px; height: 24px; background: rgba(255, 255, 255, 0.35); margin: 0 4px; }
.gumb-bijeli.v-btn { background: #fff !important; color: var(--plava) !important; }
.gumb-duh.v-btn { border-color: rgba(255, 255, 255, 0.7); }
.opasna-zona { display: flex; align-items: center; gap: 12px; margin-top: 16px; padding: 10px 14px; border: 1px dashed #e57373; border-radius: 4px; background: #fff; }
.opasna-napomena { font-size: 12px; color: var(--sivo); }

.brojke {
  display: flex; flex-wrap: wrap; gap: 14px 26px;
  background: #fff; border: 1px solid var(--crta); border-radius: 4px;
  padding: 10px 16px; margin-bottom: 12px;
}
.brojke .stavka span { display: block; font-size: 12px; color: var(--sivo); line-height: 1.2; }
.brojke .stavka b { font-size: 19px; font-variant-numeric: tabular-nums; }
.brojke .stavka b.glavno { color: var(--plava-tamna); font-size: 22px; }
.brojke .crta { width: 1px; background: var(--crta); align-self: stretch; }
.prekidac { margin-bottom: 8px; font-size: 14px; }

.stupci { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; align-items: start; }
.kartica {
  background: #fff; border: 1px solid var(--crta); border-radius: 4px;
  margin-bottom: 12px; overflow: hidden;
}
.naslov-kartice {
  font-size: 17px; font-weight: 700; letter-spacing: 0.02em;
  color: var(--plava-tamna); background: var(--plava-svijetla);
  border-bottom: 2px solid var(--plava);
  padding: 8px 16px; display: flex; align-items: center; gap: 8px;
}
.naslov-kartice .dodatak { font-size: 12px; font-weight: 400; color: var(--sivo); }
.naslov-kartice.sklopiva { cursor: pointer; user-select: none; }
.naslov-kartice .strelica { margin-left: auto; font-size: 13px; color: var(--sivo); }
.tijelo { padding: 10px 16px 14px; }
.tijelo.bez { padding: 0; }
.nema-podataka { color: var(--sivo); font-size: 14px; }

.obracun { width: 100%; border-collapse: collapse; font-variant-numeric: tabular-nums; }
.obracun td { padding: 5px 0; border-bottom: 1px solid #f0f0f0; vertical-align: baseline; }
.obracun td:last-child { text-align: right; font-weight: 500; white-space: nowrap; }
.obracun td .sitno { font-size: 12px; color: var(--sivo); }
.obracun tr.zbroj td { border-top: 2px solid var(--crta); border-bottom: none; font-weight: 700; font-size: 16px; padding-top: 8px; }
.obracun tr.zbroj td:last-child { color: var(--plava-tamna); }
.obracun tr.glavni td { font-weight: 700; font-size: 17px; }
.obracun tr.skupina td {
  font-size: 12px; font-weight: 700; text-transform: uppercase;
  letter-spacing: 0.06em; color: var(--plava-tamna); padding-top: 10px; border-bottom: 1px solid var(--crta);
}
.obracun tr.uvuceno td:first-child { padding-left: 14px; }

@media (max-width: 900px) {
  .stupci { grid-template-columns: 1fr; }
  .traka-radnik { position: static; }
  .akcije { width: 100%; }
  .traka-radnik .razmak { display: none; }
  .brojke .crta { display: none; }
}
</style>

<!-- Polja se crtaju render-funkcijom (PoljaRedovi), pa stilovi ne mogu biti scoped. -->
<style>
.emp-novi .polja { display: grid; grid-template-columns: 170px 1fr; row-gap: 7px; column-gap: 10px; }
.emp-novi .polja .naziv { color: rgba(0, 0, 0, 0.6); font-size: 14px; }
.emp-novi .polja .vrijednost { font-weight: 500; overflow-wrap: anywhere; }
.emp-novi .polja .vrijednost.prazno { color: #cfd8dc; font-weight: 400; }
.emp-novi .polja.dugi { grid-template-columns: 1fr auto; }
.emp-novi .polja.dugi .vrijednost { text-align: right; }
@media (max-width: 520px) {
  .emp-novi .polja { grid-template-columns: 120px 1fr; }
}
</style>
